module.exports = __webpack_public_path__ + "e001e2ce737fc02f67d0e4482b4d793b.fbx";